import request from '@/utils/request'

// 列表
export function listContingency(data) {
  return request({
    url: 'admin/data/mhcontingencyplan/list',
    method: 'post',
    data
  })
}

// 添加列表
export function listPlan(id) {
  return request({
    url: 'admin/data/mhcontingencyplan/listplan/'+id,
    method: 'get',
  })
}   

// 删除
export function delContingency(data) {
  return request({
    url: 'admin/data/mhcontingencyplan/delete',
    method: 'post',
    data
  })
}

// 新增
export function saveContingency(data) {
  return request({
    url: 'admin/data/mhcontingencyplan/save',
    method: 'post',
    data
  })
}
